// extracted by mini-css-extract-plugin
module.exports = {"header":"panel_header__19iQ6","body":"panel_body__3eWgR","left":"panel_left__2J4Fz","right":"panel_right__3pjlJ"};